import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/q5HAAqdLaaTY3VDjsCmoRA/ChatGPT_Image_26_may_2026,_22_02_07.webp';
// Preconnect to image CDN (highest priority — needed for LCP)
const preconnectCdn = document.createElement('link');
preconnectCdn.rel = 'preconnect';
preconnectCdn.href = 'https://cdn.magicpatterns.com';
preconnectCdn.crossOrigin = 'anonymous';
document.head.appendChild(preconnectCdn);
// Preload LCP hero image with HIGH fetch priority — first thing requested
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = HERO_IMAGE;
preloadHero.type = 'image/webp';
(preloadHero as any).fetchPriority = 'high';
document.head.appendChild(preloadHero);
// Preconnect to font CDN (needed before stylesheet request)
const preconnectFonts = document.createElement('link');
preconnectFonts.rel = 'preconnect';
preconnectFonts.href = 'https://fonts.gstatic.com';
preconnectFonts.crossOrigin = 'anonymous';
document.head.appendChild(preconnectFonts);
// Load Google Fonts NON-BLOCKING using the media=print + onload trick.
// Browser downloads the stylesheet but doesn't block render for it.
// Once it loads, we swap media to "all" which applies the styles.
// Combined with font-display=optional, this means: zero render-blocking,
// zero CLS, and zero FOUT (fallback font is used if custom font is late).
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@600;700;800;900&display=optional';
fontLink.media = 'print';
fontLink.onload = function () {
  // @ts-ignore
  this.media = 'all';
};
document.head.appendChild(fontLink);
render(<App data-id="element-292" />, document.getElementById('root'));